import React from 'react';
import AnalyticsTabbed from '../Analytics/AnalyticsTabbed';

const JumperAnalytics: React.FC = () => {
  return <AnalyticsTabbed isJumperMode={true} />;
};

export default JumperAnalytics;
